module.exports = __webpack_public_path__ + "img/73.b56c212e.webp";